import { useEffect, useState } from 'react';
import { isiOSoriPadOSDevice, isMobileSafari } from 'userAgentHelper';

const needsInteraction = () => {
    if (!window.CORDOVA && !isMobileSafari()) return false;
    return isiOSoriPadOSDevice();
};

// this "cache" object is used to store a global reference so that each hook instance doesn't
// need to wait for an event listener to be triggered
const interactionCache = {
    hasInteracted: !needsInteraction(),
    listeners: new Set<() => void>(),
};

// Some ios devices refuse to play videos if the dom has not been interacted with prior to the video being loaded
export const useHasInteractedIfNeeded = () => {
    const [hasInteractedIfNeeded, setHasInteractedIfNeeded] = useState(interactionCache.hasInteracted);

    useEffect(() => {
        if (interactionCache.hasInteracted) return undefined;

        const update = () => setHasInteractedIfNeeded(true);
        interactionCache.listeners.add(update);

        const handler = () => {
            if (interactionCache.hasInteracted) return;
            interactionCache.hasInteracted = true;
            interactionCache.listeners.forEach(listener => listener());
            interactionCache.listeners.clear();
        };

        window.addEventListener('touchstart', handler, { once: true });

        return () => {
            interactionCache.listeners.delete(update);
            window.removeEventListener('touchstart', handler);
        };
    }, []);

    return hasInteractedIfNeeded;
};
